module.exports = __webpack_public_path__ + "img/menuIcon7.74a52b24.png";